export class ProductFilterSettingsModel {
    public categoryId: number;
    public articleNumber: string;
    public article: string;
    public brand: string;
    public model: string;
    public power: string;
    public supplier: string;
    public actives: number;
}